import { observable } from "mobx";
import moment from 'moment'
import ContainersService from "../../../../services/ContainersService";
import { urlApi } from "../../../../config/Constantes";

export default class ContainersDetalhesStore {

    @observable containers;
    @observable dadosContainer;
    @observable dadosDUE;
    @observable listaDadosDue;
    @observable mensagemErro;
    @observable loadingDownloadRelatorio;

    @observable gkeyContainerAtivo;

    containerId;

    constructor(containerId, gkeyCntrAtivo) {
        this.containerId = containerId;

        this.dadosContainer = [];
        this.dadosDUE = null;
        this.listaDadosDue = null;
        this.gkeyContainerAtivo = gkeyCntrAtivo;

        if (this.gkeyContainerAtivo && this.gkeyContainerAtivo.dadosDue && this.gkeyContainerAtivo.dadosDue.length > 0) {
            this.dadosDUE = this.gkeyContainerAtivo.dadosDue[0]
            this.listaDadosDue = this.gkeyContainerAtivo.dadosDue;
        }

        this.service = new ContainersService();
        this.containers = [];

        this.entradaCntr = null;
        this.mensagemErro = "";


        this.download = document.createElement('a');
        document.body.appendChild(this.download);
        this.download.style = "display: none";
        this.download.target = "_blank";

        this.loadingDownloadRelatorio = false;
    }

    detalhar() {
        this.service.detalhar(this.containerId).then((res) => {
            if (res.status === 200 && res.data) 
               this.formataDados(res.data)
            else
              this.mensagemErro = "Erro ao carregar detalhes";
        });
    }

    setEntradaInicial = (entradaCntr = null) => {
        this.entradaCntr = entradaCntr;
    }

    formataDados = (containersRecebidos) => {
        let formatoInicial = 'DD/MM/YYYY HH:mm:ss';
        let formatoFinal = 'DD MMM, YYYY';
        containersRecebidos.forEach(c => {
            let novoContainer = c;

            if (novoContainer.container.DtInclLacre1) novoContainer.container.DtInclLacre1 = moment(novoContainer.container.DtInclLacre1, formatoInicial).format(formatoFinal);
            if (novoContainer.container.DtInclLacre2) novoContainer.container.DtInclLacre2 = moment(novoContainer.container.DtInclLacre2, formatoInicial).format(formatoFinal);
            if (novoContainer.container.DtInclLacre3) novoContainer.container.DtInclLacre3 = moment(novoContainer.container.DtInclLacre3, formatoInicial).format(formatoFinal);
            if (novoContainer.container.DtInclLacre4) novoContainer.container.DtInclLacre4 = moment(novoContainer.container.DtInclLacre4, formatoInicial).format(formatoFinal);

            //Formatando a listaDue
            if (novoContainer.dadosDue && novoContainer.dadosDue.length > 0) {
                novoContainer.dadosDue.map(d => {
                    console.log(d);
                    if (d.DataEnvio)
                    {
                        let dataE = new Date(d.DataEnvio);
                        d.DataEnvio = moment(dataE).format(formatoFinal);
                    }
                    if (d.DatEmissao)
                    {
                        let dataE = new Date(d.DatEmissao);
                        d.DatEmissao = moment(dataE).format(formatoFinal);
                    }
                    if (d.Mensagem && d.Mensagem.match(/erro/i)) d.Mensagem = 'Erro'
                })
            }

            if (this.gkeyContainerAtivo && this.gkeyContainerAtivo === novoContainer.container.UnitId) {
                this.dadosContainer = novoContainer.container;
                this.dadosDUE = novoContainer.dadosDue && novoContainer.dadosDue.length > 0 ? novoContainer.dadosDue[0] : null;
                this.listaDadosDue = novoContainer.dadosDue && novoContainer.dadosDue.length > 0 ? novoContainer.dadosDue : null;
            }

            this.containers.push(novoContainer);
        });

        if (this.dadosContainer.length === 0) {
            this.dadosContainer = this.containers[0].container;
            this.dadosDUE = this.containers[0].dadosDue ? this.containers[0].dadosDue[0] : null;
            this.listaDadosDue = this.containers[0].dadosDue ? this.containers[0].dadosDue : null;

            this.gkeyContainerAtivo = this.dadosContainer.UnitId;
        }
    }

    clickCard = (x) => {
        this.dadosContainer = this.containers[x].container;
        this.gkeyContainerAtivo = this.containers[x].container.UnitId;
        this.dadosDUE = (this.containers[x].dadosDue.length > 0) ? this.containers[x].dadosDue[0] : null;
        this.listaDadosDue = (this.containers[x].dadosDue.length > 0) ? this.containers[x].dadosDue : null;
    }

    getRelatorio = () => {
        this.loadingDownloadRelatorio = true;
        fetch(`${urlApi}/Container/Relatorio/${this.gkeyContainerAtivo}`).then(res => {
            if(res.status !== 200) {
                this.mensagemErro = "Não foi possível completar o download"; 
            } else {
                return res.blob();
            } 
        }).then(blob => {
            const url = window.URL.createObjectURL(blob)
            this.download.href = url
            this.download.download = `relatorio.pdf`
            this.download.click()
            window.URL.revokeObjectURL(url)
        }).catch(err => {console.error(err); this.mensagemErro = "Erro ao fazer o download"}
        ).finally(() => {
            this.loadingDownloadRelatorio = false;
        });
    }

    gerarRelatorioPesagem = () => {
        if(this.gkeyContainerAtivo) {
            fetch(`${urlApi}/Container/RelatorioPesagem/${this.gkeyContainerAtivo}`).then(res => {
                if(res.status !== 200) {
                    this.mensagemErro = "Não foi possível completar o download"; 
                } else {
                    return res.blob();
                } 
            }).then(blob => {
                const url = window.URL.createObjectURL(blob)
                this.download.href = url
                this.download.download = `relatorio_pesagem_${this.dadosContainer.UnitId}.pdf`
                this.download.click()
                window.URL.revokeObjectURL(url)
            }).catch(err => {console.error(err); this.mensagemErro = "Erro ao fazer o download"}
            ).finally(() => {
                this.loadingDownloadRelatorio = false;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/consultas/containers/stores/ContainersDetalhesStore.js